import React, { useEffect, useState, useMemo, useRef, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import api from "../../api";
import useDynamicPageSize from "../../useDynamicPageSize";
import { useParams, useNavigate } from "react-router-dom";
import { encryptQuery,decryptQuery } from "../../utils/encryption";
import Footer from "../../Footer";
import { useHeaderFilters } from "../../context/HeaderFilterContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Modal } from 'bootstrap';
import { toast, ToastContainer } from "react-toastify";


type EmployeeType = {
    id: number;
    name: string;
    gst_no: string;
    email: string;
    contact_number: string;
    address: string;
    is_active: boolean;
};
type ModalMode = "add" | "edit";
type EmployeeFiltersProps = {
  searchTerm: string;
  onSearchTermChange: (val: string) => void;
  onAdd: () => void;
  onResetFilters: () => void;
};


const VendorFilters: React.FC<EmployeeFiltersProps> = ({
  searchTerm,
  onSearchTermChange,
  onAdd,
  onResetFilters, // New prop
}) => {
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);  

  return (
      <div className="upper-absolute-class">
        <div className="holiday-full-width">
          <div className="d-flex align-items-center gap-2 vendor-padding-right" >
          {searchTerm.trim() && (
          <button
              className="btn add_btn_size btn-outline-primary reset-vendor"
              onClick={onResetFilters}
              title="Reset"
              >
              <i className="ti ti-refresh" />
            </button>
            )}
            <div className="holiday-flex">
            <input
              type="text"
              className="form-control search-size"
              placeholder="Search…"
              value={searchTerm}
              onChange={(e) => onSearchTermChange(e.target.value)}
              style={{width:"100%"}}
            />
            </div>
            <button className="btn btn-outline-primary add_btn_size" onClick={onAdd}>
              <i className="ti ti-circle-plus" />
            </button>
          </div>
        </div>
      </div>
  );
};

// Debounce hook
function useDebounce<T>(value: T, delay = 500): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const h = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(h);
  }, [value, delay]);
  return debounced;
}

const Vendor: React.FC = () => {
  const { setFilters } = useHeaderFilters();
  const navigate = useNavigate();

  // Pagination & data
  const [currentPage, setCurrentPage] = useState(1);
  const { encryptedQuery } = useParams<{ encryptedQuery?: string }>();
  const pageSize = useDynamicPageSize();
  const isInitialFetch = useRef(true);
  const [totalItems, setTotalItems] = useState(0);
  const [tableHeight, setTableHeight] = useState<number>(0);
   const [loading, setLoading] = useState(true);
	
	useLayoutEffect(()  => {
	  const calculateHeight = () => {
		const baseOffset = 194;
		const extraOffset = window.innerWidth <= 991 ? -43 : -81;
		const fixedOffset = baseOffset + extraOffset;
	
		const newHeight = window.innerHeight - fixedOffset;
	
		console.log('Calculated table height:', newHeight);
		console.log('fixedOffset:', fixedOffset);
		console.log('window.innerHeight:', window.innerHeight);
		console.log('pagesize:',pageSize);
		console.log('totalItems',totalItems);
	
		setTableHeight(newHeight);
	  };
	
	calculateHeight(); // initial + on totalItems change
	window.addEventListener("resize", calculateHeight);
  
	return () => window.removeEventListener("resize", calculateHeight);
  }, [totalItems, pageSize]);

  const [designationsList, setDesignationsList] = useState<EmployeeType[]>([]);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  // Filters
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  // Validation error state
  const [formErrors, setFormErrors] = useState<{
        name?: string;
        gst_no?: string;
        contact_number?: string;
        email?: string;
    }>({});
  // Modal/Form
  const [formData, setFormData] = useState({
    name: '',
    gst_no: '',
    email: '',
    contact_number: '',
    address: '',
    is_active: false
    });
  const [editId, setEditId] = useState<number | null>(null);
  const [modalMode, setModalMode] = useState<"add" | "edit">("add");
   // open modal (add or edit)
   const openModal = (mode: ModalMode, rec?: EmployeeType) => {
    setFormErrors({});
    setModalMode(mode);
    setFormData({
        name: '',
        gst_no: '',
        email: '',
        contact_number: '',
        address: '',
        is_active: false
    });
    setEditId(null);
    if (mode === 'edit' && rec) {
        setFormData({
            name: rec.name,
            gst_no: rec.gst_no,
            email: rec.email,
            contact_number: rec.contact_number,
            address: rec.address,
            is_active: Boolean(rec.is_active)
        });
        setEditId(rec.id);
    }
    const el = document.getElementById('payheader_modal');
    if (el) {
        const bsModal = (window as any).bootstrap.Modal.getOrCreateInstance(el);
        bsModal.show();
    }
};

  const handleAddInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
    if (value.trim() !== '') {
        setFormErrors((prev) => ({ ...prev, [name]: '' }));
      }
};

const hideModal = (modalId: string) => {
    const el = document.getElementById(modalId);
    if (!el) return;
    const bsModal = Modal.getInstance(el) ?? new Modal(el)
    bsModal.hide()
    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    }, 300);
  };

  const handleSubmit = async () => {
    const errors: any = {};
    console.log('Form data:', formData);
    if (!formData.name?.trim()) errors.name = "Name is required.";
    if (!formData.gst_no?.trim()) errors.gst_no = "GST Number is required.";
    if (!formData.email?.trim()) {
      errors.email = "Email is required.";
    } else {
      // Email format validation (Regex for basic email validation)
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.email.trim())) {
        errors.email = "Please enter a valid email address.";
      }
    }
    const contactNumber = formData.contact_number?.trim();
    if (!contactNumber) {
        errors.contact_number = "Contact Number is required.";
    } else if (!/^\d{10}$/.test(contactNumber)) {
        errors.contact_number = "Contact Number must be exactly 10 digits.";
    }

    if (Object.keys(errors).length > 0) {
        console.log("Validation Errors:", errors); // <--- Add this
        setFormErrors(errors);
        return;
    }
    try {
        const body: Record<string, any> = {
            name: formData.name.trim(),
            gst_no: formData.gst_no.trim(),
            email: formData.email.trim(),
            contact_number: formData.contact_number,
            address: formData.address,
            is_active: formData.is_active,
        };
        if (modalMode === 'edit' && editId != null) body.id = editId;
        const res = await api<{ success: boolean; data: any; error?: string; message?: string }>("/save-vendor", {
            method: "POST",
            body
        });

        if (res.success) {
            if (modalMode === "edit") {
              await fetchEmployees();
            } else {
              // For add mode:
              setTotalItems((prevCount) => {
                const newCount = prevCount + 1;
                setCurrentPage(1);
                fetchEmployees();
                return newCount;
              });
            }
            const closeBtn = document.getElementById('close-modal') as HTMLButtonElement;
            if (closeBtn) {
              closeBtn.click(); 
            }
            toast.success(
                modalMode === 'add'
                    ? 'Vendor added successfully!'
                    : 'Vendor updated successfully!'
            );
        } else {
            const msg = res.error?.toLowerCase().includes('duplicate')
                ? 'Duplicate Vendor! Vendor already exists.'
                : res.error || 'Failed to save Vendor.';
            toast.error(msg);
        }
    } catch (err: any) {
            if (err.response?.data) {
              const data = err.response.data;
              const msg =
                data.error ||
                data.message ||
                err.message ||
                "Something went wrong.";
              toast.error(msg);
            } else {
              toast.error(err.message || "Something went wrong.");
            }
          }
};

const fieldLabels: { [key: string]: string } = {
    gst_no: 'GST No',
    contact_number: 'Contact Number',
    is_active: 'Is Active',
};

  const handleResetFilters = () => {
    setSearchTerm("");
    navigate(`/vendors`, { replace: false });

  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (value.trim() === '') {
        const label = fieldLabels[name] || name.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
        setFormErrors((prev) => ({
            ...prev,
            [name]: `${label} is required.`,
        }));
    }
};

const handleDelete = async (id: number) => {
  console.log("delete",id)
    try {
        const res = await api<{ success: boolean; error?: string }>(`/delete-vendor/${id}`, { method: 'DELETE' });
        if (res.success) {
            setTotalItems((prevCount) => prevCount - 1);
            toast.success('Vendor deleted successfully!');
            // Calculate the total pages after deletion
            const totalPages = Math.ceil((totalItems - 1) / pageSize);
            // If the current page number is now greater than totalPages, move back one page
            if (currentPage > totalPages) {
              setCurrentPage(totalPages > 0 ? totalPages : 1);
            } else {
              await fetchEmployees();
            }
        } else {
            toast.error(res.error || 'Failed to delete Vendor.');
        }
    } catch (err: any) {
        if (err.response?.data) {
          const data = err.response.data;
          const msg =
            data.error ||
            data.message ||
            err.message ||
            "Something went wrong.";
          toast.error(msg);
        } else {
          toast.error(err.message || "Something went wrong.");
        }
      }
};

    interface VendorFilters {   
    searchTerm: string | null;
    currentPage?: number;
    }

    const defaultVendorFilters: VendorFilters = {
  searchTerm: null,
  currentPage: 1,
};

const areVendorFiltersDefault = (filters: VendorFilters) => {
  return (
    (!filters.searchTerm || filters.searchTerm.trim() === "") &&
    (filters.currentPage ?? 1) === defaultVendorFilters.currentPage
  );
};

    useEffect(() => {
        if (encryptedQuery) {
          try {
            const decoded = decodeURIComponent(encryptedQuery);
            const result = decryptQuery(decoded);
      
            if (result && typeof result === 'object') {
              const data = result as VendorFilters;
      
              setSearchTerm(data.searchTerm || "");
              setCurrentPage(data.currentPage ?? 1);
              return;
            }
          } catch (e) {
            console.warn("Failed to decrypt attendance query:", e);
          }
        }
        // Fallback if no encrypted query or decryption fails
        setSearchTerm("");;
      }, [encryptedQuery]);

      const updateFilterUrl = (
        filters: VendorFilters,
        baseRoute: string = "/vendors"
      ) => {
        if (areVendorFiltersDefault(filters)) {
          navigate(baseRoute, { replace: false });
        } else {
          const encrypted = encryptQuery(filters);
          const encoded = encodeURIComponent(encrypted);
          navigate(`${baseRoute}/${encoded}`, { replace: false });
        }
      };
      useEffect(() => {
          // Call updateFilterUrl with the current search term whenever it changes
          updateFilterUrl({
            searchTerm: debouncedSearchTerm || null,
            currentPage
          });
      }, [debouncedSearchTerm, currentPage]);
      
 const openDeleteModal = (id: number) => {
    setDeleteId(id);
    const modalElement = document.getElementById("top-modal");
    if (modalElement) {
      const modalInstance = (window as any).bootstrap.Modal.getOrCreateInstance(
        modalElement
      );
      modalInstance.show();
    }
  };
  const columns = [
    { title: 'Name',width:'20%', dataIndex: 'name', render: (t: string) => {return t} },
    { title: 'GST No',width:'20%', dataIndex: 'gst_no', render: (t: string) => {return t} },
    { title: 'Email', width:'20%',dataIndex: 'email', render: (t: string) => {return t} },
    { title: 'Contact No',width:'10%', dataIndex: 'contact_number', render: (t: string) => {return t}},
    { title: 'Address', width:'20%',dataIndex: 'address', render: (t: string) => {return t} },
    {
        title: 'Action', dataIndex: 'actions', render: (_: any, rec: EmployeeType) => (
            <div className="action-icon d-inline-flex">
                <Link to="#" onClick={() => openModal('edit', rec)}>
                    <i className="ti ti-edit" />
                </Link>
                <Link to="#" onClick={() => openDeleteModal(rec.id)}><i className="ti ti-trash" />
                </Link>
            </div>
        )
    }
];

  const fetchEmployees = async () => {
    try {
        setLoading(true);
        const res = await api<any>('/vendor-list', {
            method: 'POST',
            body: { currentPage, pageSize: pageSize,searchTerm: debouncedSearchTerm || undefined, },
        });
        console.log('Raw API response:', res);
        const apiData = res?.vendors;
        setDesignationsList(apiData.data.map((rec: any) => ({ id: rec.id, gst_no: rec.gst_no, email: rec.email, name: rec.name, contact_number: rec.contact_number, address: rec.address, is_active: rec.is_active })));
        setTotalItems(apiData.total);
    } catch (err: any) {
        console.error('Fetch error:', err.message);
    }finally{
        setLoading(false);
    }
  };

  useEffect(() => {
     if (isInitialFetch.current) {
      isInitialFetch.current = false;
      return;
    }
    fetchEmployees();
  }, [
    currentPage,
    pageSize,
    debouncedSearchTerm,
  ]);

  const filtersNode = useMemo(
    () => (
      <VendorFilters
        onResetFilters={handleResetFilters}
        searchTerm={searchTerm}
        onSearchTermChange={(val) => {
          setSearchTerm(val);
          setCurrentPage(currentPage);
        }}
        onAdd={() => openModal("add")}
      />
    ),
    [
      searchTerm,
    ]
  );

  useEffect(() => {
    setFilters(filtersNode);
    return () => {
      setFilters(null);
    };
}, [filtersNode]);
  return (
    <>
    <div className="page-wrapper d-flex flex-column">
      <div className="content flex-grow-1"> 

        <div className="card card-margin-bottom">
          <div className="card-body p-0" id="Designation-list" style={{ height: tableHeight, display: "flex", flexDirection: "column" }}>
            <Table
			        style={{ flex: 1 }}
              dataSource={designationsList}
              columns={columns}
              onPageChange={setCurrentPage}
              totalItems={totalItems}
              pageSize={pageSize}
              currentPage={currentPage}
              loading={loading}
            />

          </div>
        </div>
      </div>
   {/* Add-Edit Modal */}
   <div className="modal fade" id="payheader_modal"><div className="modal-dialog modal-md modal-dialog-centered"><div className="modal-content">
                <div className="modal-header"><h4 className="modal-title">{modalMode === 'add' ? 'Add Vendor' : 'Edit Vendor'}</h4>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />      
                  </div>
                <div className="modal-body pb-0">
                    <div className="mb-3">
                        <label className="form-label">Name <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="name" onChange={handleAddInputChange} onBlur={handleBlur} value={formData.name} />
                        {formErrors.name && <small className="text-danger">{formErrors.name}</small>}
                    </div>
                    <div className="mb-3">
                        <label className="form-label">GST No <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="gst_no" onChange={handleAddInputChange} onBlur={handleBlur} value={formData.gst_no} />
                        {formErrors.gst_no && <small className="text-danger">{formErrors.gst_no}</small>}
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input type="text" className="form-control" name="address" onChange={handleAddInputChange} onBlur={handleBlur} value={formData.address} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Email <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="email" onChange={handleAddInputChange} onBlur={handleBlur} value={formData.email} />
                        {formErrors.email && <small className="text-danger">{formErrors.email}</small>}
                    </div>
                    <div className="row">
                        <div className="col-md-8 mb-3">
                            <label className="form-label">
                                Contact No <span className="text-danger">*</span>
                            </label>
                            <input
                                type="tel"
                                className="form-control"
                                name="contact_number"
                                onChange={handleAddInputChange}
                                onBlur={handleBlur}
                                value={formData.contact_number}
                                maxLength={10} 
                                pattern="\d*" 
                                onInput={(e: React.FormEvent<HTMLInputElement>) => {
                                    const input = e.target as HTMLInputElement;
                                    input.value = input.value.replace(/[^0-9]/g, "");
                                }}
                            />
                            {formErrors.contact_number && (
                                <small className="text-danger">{formErrors.contact_number}</small>
                            )}
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Is Active</label>
                            <div className="form-check d-flex align-items-center">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="is_active"
                                    name="is_active"
                                    checked={formData.is_active}
                                    onChange={handleAddInputChange}
                                />
                                <label className="form-check-label ms-2" htmlFor="is_active">
                                    Active
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                <button className="btn btn-cancel" id= "close-modal" data-bs-dismiss="modal">Cancel</button> 
                <button className="btn btn-primary" onClick={handleSubmit}>{editId ? 'Update' : 'Add'}</button>
                </div>
            </div>
            </div>
            </div>
       {/* Delete Confirmation Modal */}
       <div id="top-modal" className="modal fade" >
                <div className="modal-dialog modal-top">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Delete Vendor</h4>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this record?</p>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-cancel" data-bs-dismiss="modal">
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={() => deleteId !== null && handleDelete(deleteId)}
                                data-bs-dismiss="modal"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
			<div>
            <Footer />
			</div>
        </div>
        <ToastContainer position="top-right" autoClose={3000} /></>
  );
};

export default Vendor;